import Vue from 'vue';
import Vuex from 'vuex';

import device from './modules/device';
import facemapping from './modules/facemapping';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: { device, facemapping },
    strict: process.env.NODE_ENV !== 'production'
    // plugins: debug ? [createLogger()] : []
});
